package it.neckar.lizergy.model.http

import it.neckar.open.http.UrlParameterName

/**
 * Contains ants for parameters
 */
object EndpointsParameters {
  val searchTerm: UrlParameterName = UrlParameterName("searchTerm")
  val projectId: UrlParameterName = UrlParameterName("projectId")
  val configurationId: UrlParameterName = UrlParameterName("configurationId")
  val quoteSnapshotId: UrlParameterName = UrlParameterName("quoteSnapshotId")
  val Uuid: UrlParameterName = UrlParameterName("Uuid")

  val startDate: UrlParameterName = UrlParameterName("startDate")
  val endDate: UrlParameterName = UrlParameterName("endDate")

  val invoiceNumber: UrlParameterName = UrlParameterName("invoiceNumber")
  val expectedProjectCount: UrlParameterName = UrlParameterName("expectedProjectCount")
  val expectedTotalRevenue: UrlParameterName = UrlParameterName("expectedTotalRevenue")

  val listProcessStates: UrlParameterName = UrlParameterName("listProcessStates")

  val priceListExportCategory: UrlParameterName = UrlParameterName("priceListExportCategory")
}
